<template id="application_dashboard">
    <div class="row">
        <div class="col-sm-12">
            <div class="panel panel-default">
                <div class="panel-heading">
                    <h3 class="panel-title">Applications <small v-if="is_external">View existing applications and lodge new ones</small>
                        <a :href="'#'+pBody" data-toggle="collapse"  data-parent="#userInfo" expanded="true" :aria-controls="pBody">
                            <span class="glyphicon glyphicon-chevron-up pull-right "></span>
                        </a>
                    </h3>
                </div>
                <div class="panel-body collapse in" :id="pBody">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="">Licence Category</label>
                                <select class="form-control" v-model="filterApplicationLicenceType">
                                    <option value="All">All</option>
                                    <option v-for="lt in application_licence_types" :value="lt.name" v-bind:key="`licence_type_${lt.id}`">{{lt.name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="">Status</label>
                                <select class="form-control" v-model="filterApplicationStatus">
                                    <option value="All">All</option>
                                    <option v-for="s in application_status" :value="s" v-bind:key="`status_${s.id}`">{{s.name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="">Licence Activity</label>
                                <select class="form-control" v-model="filterApplicationActivity">
                                    <option value="All">All</option>
                                    <option v-for="a in application_activities" :value="a.value" v-bind:key="`activity_${a.value}`">{{a.label}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <router-link  style="margin-top:25px;" class="btn btn-primary pull-right" :to="{ name: 'apply_application_organisation' }">New Application</router-link>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <label for="">Lodged From</label>
                            <div class="input-group date" ref="applicationDateFromPicker">
                                <input type="text" class="form-control" placeholder="DD/MM/YYYY" v-model="filterApplicationLodgedFrom">
                                <span class="input-group-addon">
                                    <span class="glyphicon glyphicon-calendar"></span>
                                </span>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label for="">Lodged To</label>
                            <div class="input-group date" ref="applicationDateToPicker">
                                <input type="text" class="form-control" placeholder="DD/MM/YYYY" v-model="filterApplicationLodgedTo">
                                <span class="input-group-addon">
                                    <span class="glyphicon glyphicon-calendar"></span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row"><br/></div> 
                    <div class="row">
                        <div class="col-lg-12">
                            <datatable v-if="level=='external'" ref="external_application_datatable" :id="datatable_id" :dtOptions="application_ex_options" :dtHeaders="application_ex_headers"/>
                            <datatable v-else ref="application_datatable" :id="datatable_id" :dtOptions="application_options" :dtHeaders="application_headers"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import datatable from '@/utils/vue/datatable.vue'
require("select2/dist/css/select2.min.css");
require("select2-bootstrap-theme/dist/select2-bootstrap.min.css");
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex'
import {
    api_endpoints,
    helpers
}from '@/utils/hooks'
import '@/scss/dashboards/application.scss';
export default {
    name: 'ApplicationTableDash',
    props: {
        level:{
            type: String,
            required: true,
            validator:function(val) {
                let options = ['internal','external'];
                return options.indexOf(val) != -1 ? true: false;
            }
        },
        url:{
            type: String,
            required: true
        }
    },
    data() {
        let vm = this;
        let internal_application_headers = ["Number","Category","Activity","Type","Submitter","Applicant","Status","Payment Status","Lodged on","Action"];
        let internal_columns = [
            {
                data: "lodgement_number",
                width: "10%",
                className: "app-row-icon",
            },
            {
                data: "category_name",
                width: "10%",
                className: "normal-white-space",
                orderable: false,
                searchable: false // handled by filter_queryset override method - class ApplicationFilterBackend
            },
            {
                data: "purpose_string",
                width: "30%",
                mRender:function (data,type,full) {
                    let output = data.replace(/(?:\r\n|\r|\n|,)/g, '<br>');
                    return output;
                },
                orderable: false,
                //searchable: false // handled by filter_queryset override method - class ApplicationFilterBackend
                name: "licence_purposes__name",
            },
            {
                data: "application_type",
                width: "10%",
                mRender:function (data,type,full) {
                    return data.name;
                },
                searchable: false
            },
            {
                data: "submitter",
                visible: false,
                className: "normal-white-space",
                name: "submitter__first_name, submitter__last_name, submitter__email",
                mRender:function (data,type,full) {
                    if (data) {
                        return `${data.first_name} ${data.last_name}`;
                    }
                    return ''
                },
            },
            {
                data: "applicant",
                width: "10%",
                className: "normal-white-space",
                orderable: false,
                searchable: false // handled by filter_queryset override method - class ApplicationFilterBackend
            },
            {
                data: "processing_status",
                width: "10%",
                className: "normal-white-space",
                mRender:function(data,type,full){
                    return data.name;
                },
                orderable: false,
                searchable: false // handled by filter_queryset override method - class ApplicationFilterBackend
            },
            {
                data: "payment_status",
                visible: false,
                orderable: false,
                searchable: false // handled by filter_queryset override method - class ApplicationFilterBackend
            },
            {
                data: "lodgement_date",
                width: "10%",
                mRender:function (data,type,full) {
                    return data != '' && data != null ? moment(data).format(vm.dateFormat): '';
                },
                searchable: false // handled by filter_queryset override method - class ApplicationFilterBackend
            },
            {
                // Actions
                width: "10%",
                mRender:function (data,type,full) {
                    let links = '';
                    if (!vm.is_external){
                        const finalised = ['approved', 'declined', 'awaiting_payment'].includes(full.processing_status.id);
                        links += (full.can_be_processed && full.user_in_officers) ?
                            `<a href='/internal/application/${full.id}'>Process</a><br/>` :
                            `<a href='/${!vm.is_external ? 'internal' : 'external'}/application/${full.id}'>View</a><br/>`;
                    }
                    if (!vm.is_external && vm.canViewPayments && ['paid','partially_paid'].includes(full.payment_status)){
                        links +=  `<a href='${full.all_payments_url}' target='_blank' >View Payment</a><br/>`;
                    }
                    if (!vm.is_external && vm.canViewPayments && full.payment_status=='under_paid'){
                        links = ''
                        links +=  `<a href='${full.all_payments_url}' target='_blank' >Record Payment</a><br/>`;
                    }
                    if (!vm.is_external && vm.canViewPayments && full.payment_status=='over_paid'){
                        links +=  `<a href='${full.all_payments_url}' target='_blank' >Refund Payment</a><br/>`;
                    }
                    if (vm.is_external){
                        if (full.can_current_user_edit) {
                            links +=  `<a href='/external/application/${full.id}'>Continue</a><br/>`;
                        }
                        if(vm.canDiscardApplication(full)) {
                            links +=  `<a href='#${full.id}' data-discard-application='${full.id}'>Discard</a><br/>`;
                        }
                    }
                    return links;
                },
                orderable: false,
                searchable: false
            }
        ]
        
        let external_columns = [
            {
                data: "lodgement_number",
                width: "10%",
                className: "app-row-icon",                
            },
            {
                data: "category_name",
                width: "10%",
                orderable: false,
                searchable: false // handled by filter_queryset override method - class ApplicationFilterBackend
            },
            {
                data: "purpose_string",
                width: "30%",
                mRender:function (data,type,full) {
                    let output = data.replace(/(?:\r\n|\r|\n|,)/g, '<br>');
                    return output;
                },
                orderable: false,
                searchable: false // handled by filter_queryset override method - class ApplicationFilterBackend
            },
            {
                data: "application_type",
                width: "10%",
                mRender:function (data,type,full) {
                    return data.name;
                }
            },
            {
                data: "submitter",
                visible: false,
                name: "submitter__first_name, submitter__last_name, submitter__email",
                mRender:function (data,type,full) {
                    if (data) {
                        return `${data.first_name} ${data.last_name}`;
                    }
                    return ''
                }
            },
            {
                data: "applicant",
                width: "10%",
                className: "normal-white-space",
                orderable: false,
                searchable: false // handled by filter_queryset override method - class ApplicationFilterBackend
            },
            {
                data: "customer_status",
                width: "10%",
                mRender:function(data,type,full){
                    return data.name;
                },
                className: "normal-white-space",
                orderable: false,
                searchable: false // handled by filter_queryset override method - class ApplicationFilterBackend
            },
            {
                data: "lodgement_date",
                width: "10%",
                mRender:function (data,type,full) {
                    return data != '' && data != null ? moment(data).format(vm.dateFormat): '';
                },
                className: "normal-white-space",
                searchable: false // handled by filter_queryset override method - class ApplicationFilterBackend
            },
            {
                // Actions
                width: "10%",
                mRender:function (data,type,full) {
                    let links = '';
                    if (!vm.is_external){
                        links +=  `<a href='/internal/application/${full.id}'>View</a><br/>`;
                    }
                    else{
                        if (full.can_current_user_edit) {
                            links +=  `<a href='/external/application/${full.id}'>Continue</a><br/>`;
                        }
                        if(vm.canDiscardApplication(full)) {
                            links +=  `<a href='#${full.id}' data-discard-application='${full.id}'>Discard</a><br/>`;
                        }
                        if (full.can_user_view) {
                            links +=  `<a href='/external/application/${full.id}'>View</a><br/>`;
                        }
                        if (full.can_pay_application){
                            links +=  `<a href='#${full.id}' data-pay-application-fee='${full.id}'>Pay Application Fee</a><br/>`;
                        }
                        if (full.can_pay_licence){
                            // let activity = full.activities.find(activity => activity.can_pay_licence_fee=true)
                            links +=  `<a href='#${full.id}' data-pay-application-licence-fee='${full.id}' pay-licence-fee-for='${full.pay_activity_id}'>Pay Additional Fee</a><br/>`;
                        }                        
                    }
                    return links;
                },
                orderable: false,
                searchable: false
            }
        ]
        return {
            pBody: 'pBody' + vm._uid,
            datatable_id: 'application-datatable-'+vm._uid,
            // Filters for Applications
            filterApplicationLicenceType: 'All',
            filterApplicationStatus: 'All',
            filterApplicationLodgedFrom: '',
            filterApplicationLodgedTo: '',
            filterApplicationSubmitter: 'All',
            filterApplicationActivity: 'All',
            dateFormat: 'DD/MM/YYYY',
            datepickerOptions:{
                format: 'DD/MM/YYYY',
                showClear:true,
                useCurrent:false,
                keepInvalid:true,
                allowInputToggle:true
            },
            application_licence_types : [],
            application_submitters: [],
            // application_status: [       // Processing status
            //     {'id': 'draft', 'name': 'Draft'},
            //     {'id': 'under_review', 'name': 'Under Review'},
            //     {'id': 'awaiting_payment', 'name': 'Awaiting Payment'},
            //     {'id': 'approved', 'name': 'Approved'},
            //     {'id': 'partially_approved', 'name': 'Partially Approved'},
            //     {'id': 'declined', 'name': 'Declined'},
            //     {'id': 'discarded', 'name': 'Discarded'},
            // ],
            application_status: [],
            // customer_status: [
            //     {'id': 'draft', 'name': 'Draft'},
            //     {'id': 'under_review', 'name': 'Under Review'},
            //     {'id': 'awaiting_payment', 'name': 'Awaiting Payment'},
            //     {'id': 'accepted', 'name': 'Approved'},
            //     {'id': 'partially_approved', 'name': 'Partially Approved'},
            //     {'id': 'declined', 'name': 'Declined'},
            // ],
            application_ex_headers: ["Number","Category","Activity","Type","Submitter","Applicant","Status","Lodged on","Action"],
            application_ex_options:{
                serverSide: true,
                searchDelay: 1000,
                lengthMenu: [ [10, 25, 50, 100, -1], [10, 25, 50, 100, "All"] ],
                order: [
                    [0, 'desc']
                ],
                autoWidth: false,
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                rowCallback: function (row, data){
                    $(row).addClass('appRecordRow');
                },
                responsive: false,
                ajax: {
                    "url": vm.url,
                    "dataSrc": 'data',
                    // adding extra GET params for Custom filtering
                    "data": function (d) {
                        d.category_name = vm.filterApplicationLicenceType;
                        d.customer_status = vm.filterApplicationStatus.id;
                        d.submitter = vm.filterApplicationSubmitter;
                        d.date_from = vm.filterApplicationLodgedFrom != '' && vm.filterApplicationLodgedFrom != null ? moment(vm.filterApplicationLodgedFrom, 'DD/MM/YYYY').format('YYYY-MM-DD'): '';
                        d.date_to = vm.filterApplicationLodgedTo != '' && vm.filterApplicationLodgedTo != null ? moment(vm.filterApplicationLodgedTo, 'DD/MM/YYYY').format('YYYY-MM-DD'): '';
                        d.activity_purpose = vm.filterApplicationActivity;
                    }
                },
                columns: external_columns,
                processing: true,
                initComplete: function () {
                    var $searchInput = $('div.dataTables_filter input');
                    $searchInput.unbind('keyup search input');
                    $searchInput.bind('keypress', (vm.delay(function(e) {
                        if (e.which == 13) {
                            vm.visibleDatatable.vmDataTable.search( this.value ).draw();
                        }
                    }, 0)));
                    // Grab Category from the data in the table
                    // var titleColumn = vm.visibleDatatable.vmDataTable.columns(vm.getColumnIndex('category'));
                    // titleColumn.data().unique().sort().each( function ( d, j ) {
                    //     let categoryTitles = [];
                    //     $.each(d,(index,a) => {
                    //         a != null && categoryTitles.indexOf(a) < 0 ? categoryTitles.push(a): '';
                    //     })
                    //     vm.application_licence_types = categoryTitles;
                    // });
                    // Grab submitters from the data in the table
                    var submittersColumn = vm.visibleDatatable.vmDataTable.columns(vm.getColumnIndex('submitter'));
                    submittersColumn.data().unique().sort().each( function ( d, j ) {
                        var submitters = [];
                        $.each(d,(index,s) => {
                            if (!submitters.find(submitter => submitter.email == s.email) || submitters.length == 0){
                                submitters.push({
                                    'email':s.email,
                                    'search_term': `${s.first_name} ${s.last_name} (${s.email})`
                                });
                            }
                        });
                        vm.application_submitters = submitters;
                    });
                    // Grab Status from the data in the table
                    // var statusColumn = vm.visibleDatatable.vmDataTable.columns(vm.getColumnIndex('status'));
                    // statusColumn.data().unique().sort().each( function ( d, j ) {
                    //     let statusTitles = [];
                    //     $.each(d,(index,a) => {
                    //         a != null && !statusTitles.filter(status => status.id == a.id ).length ? statusTitles.push(a): '';
                    //     })
                    //     //vm.application_status = statusTitles;
                    //     vm.application_status = vm.customer_status;
                    // });
                }
            },
            application_headers:internal_application_headers,
            application_options:{
                serverSide: true,
                searchDelay: 1000,
                lengthMenu: [ [10, 25, 50, 100, -1], [10, 25, 50, 100, "All"] ],
                order: [
                    [0, 'desc']
                ],
                autoWidth: false,
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                rowCallback: function (row, data){
                    $(row).addClass('appRecordRow');
                },
                responsive: false,
                ajax: {
                    "url": vm.url,
                    "dataSrc": 'data',
                    // adding extra GET params for Custom filtering
                    "data": function (d) {
                        d.category_name = vm.filterApplicationLicenceType;
                        d.processing_status = vm.filterApplicationStatus.id;
                        d.submitter = vm.filterApplicationSubmitter;
                        d.date_from = vm.filterApplicationLodgedFrom != '' && vm.filterApplicationLodgedFrom != null ? moment(vm.filterApplicationLodgedFrom, 'DD/MM/YYYY').format('YYYY-MM-DD'): '';
                        d.date_to = vm.filterApplicationLodgedTo != '' && vm.filterApplicationLodgedTo != null ? moment(vm.filterApplicationLodgedTo, 'DD/MM/YYYY').format('YYYY-MM-DD'): '';
                        d.activity_purpose = vm.filterApplicationActivity;
                    }
                },
                columns: internal_columns,
                processing: true,
                initComplete: function () {
                    var $searchInput = $('div.dataTables_filter input');
                    $searchInput.unbind('keyup search input');
                    $searchInput.bind('keypress', (vm.delay(function(e) {
                        if (e.which == 13) {
                            vm.visibleDatatable.vmDataTable.search( this.value ).draw();
                        }
                    }, 0)));
                    // Grab Activity from the data in the table
                    // var titleColumn = vm.visibleDatatable.vmDataTable.columns(vm.getColumnIndex('category'));
                    // titleColumn.data().unique().sort().each( function ( d, j ) {
                    //     let activityTitles = [];
                    //     $.each(d,(index,a) => {
                    //         a != null && activityTitles.indexOf(a) < 0 && a.length ? activityTitles.push(a): '';
                    //     })
                    //     vm.application_licence_types = activityTitles;
                    // });
                    // Grab submitters from the data in the table
                    var submittersColumn = vm.visibleDatatable.vmDataTable.columns(vm.getColumnIndex('submitter'));
                    submittersColumn.data().unique().sort().each( function ( d, j ) {
                        var submitters = [];
                        $.each(d,(index, submitter) => {
                            if (!submitters.find(item => item.email == submitter.email || submitters.length == 0)){
                                submitters.push({
                                    'email':submitter.email,
                                    'search_term': `${submitter.first_name} ${submitter.last_name} (${submitter.email})`
                                });
                            }
                        });
                        vm.application_submitters = submitters;
                    });
                    var statusColumn = vm.visibleDatatable.vmDataTable.columns(vm.getColumnIndex('status'));
                    statusColumn.data().unique().sort().each( function ( d, j ) {
                        let statusTitles = [];
                        $.each(d,(index,a) => {
                            a != null && !statusTitles.filter(status => status.id == a.id ).length ? statusTitles.push(a): '';
                        })
                        // vm.application_status = statusTitles;
                    });

                    // Fix the table rendering columns
                    vm.visibleDatatable.vmDataTable.columns.adjust().responsive.recalc();
                }
            },
            activities : [],
            application_activities: [],
        }
    },
    components:{
        datatable
    },
    watch:{
        filterApplicationStatus: function() {
            this.visibleDatatable.vmDataTable.draw();
        },
        filterApplicationSubmitter: function(){
            this.visibleDatatable.vmDataTable.draw();
        },
        filterApplicationLodgedFrom: function(){
            this.visibleDatatable.vmDataTable.draw();
        },
        filterApplicationLodgedTo: function(){
            this.visibleDatatable.vmDataTable.draw();
        },
        filterApplicationLicenceType: function(){
            this.visibleDatatable.vmDataTable.draw();
        },
        filterApplicationActivity: function(){
            this.visibleDatatable.vmDataTable.draw();
        },
    },
    computed: {
        ...mapGetters([
            'canViewPayments',
            'current_user',
            'isIdentifiedUser',
        ]),
        visibleHeaders: function() {
            return this.is_external ? this.application_ex_headers : this.application_headers;
        },
        visibleDatatable: function() {
            return this.is_external ? this.$refs.external_application_datatable : this.$refs.application_datatable;
        },
        is_external: function(){
            return this.level == 'external';
        },
    },
    methods:{
        ...mapActions([
            'loadCurrentUser',
        ]),
        canDiscardApplication: function(application) {
            return application.processing_status.id === 'draft';
        },
        discardApplication:function (application_id) {
            let vm = this;
            swal({
                title: "Discard Application",
                text: "Are you sure you want to discard this application?",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: 'Discard Application',
                confirmButtonColor:'#d9534f'
            }).then((result) => {
                if (result.value) {
                    vm.$http.delete(api_endpoints.discard_application(application_id))
                    .then((response) => {
                        swal(
                            'Discarded',
                            'Your application has been discarded',
                            'success'
                        )
                        vm.visibleDatatable.vmDataTable.ajax.reload();
                    }, (error) => {
                        swal(
                            'Discard Error',
                            helpers.apiVueResourceError(error),
                            'error'
                        )
                    });
                }
            },(error) => {
            });
        },
        delay(callback, ms) {
            var timer = 0;
            return function () {
                var context = this, args = arguments;
                clearTimeout(timer);
                timer = setTimeout(function () {
                    callback.apply(context, args);
                }, ms || 0);
            };
        },
        payLicenceFee: function(application_id, activity_id) {
            this.$http.post(helpers.add_endpoint_join(api_endpoints.applications,application_id+'/licence_fee_checkout/'), {
                application_id,
                activity_id
            }).then(res=>{
                    window.location.href = "/ledger/checkout/checkout/payment-details/";
                },err=>{
                    swal(
                        'Submit Error',
                        helpers.apiVueResourceError(err),
                        'error'
                    )
                });
        },
        payApplicationFee: function(application_id) {
            this.$http.post(helpers.add_endpoint_join(api_endpoints.applications,application_id+'/application_fee_checkout/'), application_id).then(res=>{
                    window.location.href = "/ledger/checkout/checkout/payment-details/";
                },err=>{
                    swal(
                        'Submit Error',
                        helpers.apiVueResourceError(err),
                        'error'
                    )
                });
        },
        getActivities: async function(application_id) {
            await this.$http.post(helpers.add_endpoint_join(api_endpoints.applications,application_id+'/get_activities/'), {
                application_id
            }).then(res=>{

                    this.activities = res.body;

                },err=>{
                    swal(
                        'Get Activity Error',
                        helpers.apiVueResourceError(err),
                        'error'
                    )
                });
        },
        addEventListeners: function(){
            let vm = this;
            // Initialise Application Date Filters
            $(vm.$refs.applicationDateToPicker).datetimepicker(vm.datepickerOptions);
            $(vm.$refs.applicationDateToPicker).on('dp.change', function(e){
                if ($(vm.$refs.applicationDateToPicker).data('DateTimePicker').date()) {
                    vm.filterApplicationLodgedTo =  e.date.format('DD/MM/YYYY');
                }
                else if ($(vm.$refs.applicationDateToPicker).data('date') === "") {
                    vm.filterApplicationLodgedTo = "";
                }
             });
            $(vm.$refs.applicationDateFromPicker).datetimepicker(vm.datepickerOptions);
            $(vm.$refs.applicationDateFromPicker).on('dp.change',function (e) {
                if ($(vm.$refs.applicationDateFromPicker).data('DateTimePicker').date()) {
                    vm.filterApplicationLodgedFrom = e.date.format('DD/MM/YYYY');
                    $(vm.$refs.applicationDateToPicker).data("DateTimePicker").minDate(e.date);
                }
                else if ($(vm.$refs.applicationDateFromPicker).data('date') === "") {
                    vm.filterApplicationLodgedFrom = "";
                    $(vm.$refs.applicationDateToPicker).data("DateTimePicker").minDate(false);
                }
            });
            // External Discard listener
            vm.visibleDatatable.vmDataTable.on('click', 'a[data-discard-application]', function(e) {
                e.preventDefault();
                var id = $(this).attr('data-discard-application');
                vm.discardApplication(id);
            });
            // External Pay Application Fee listener
            vm.visibleDatatable.vmDataTable.on('click', 'a[data-pay-application-fee]', function(e) {
                e.preventDefault();
                var id = $(this).attr('data-pay-application-fee');
                vm.payApplicationFee(id);
            });        
            // External Pay Licence Fee listener
            vm.visibleDatatable.vmDataTable.on('click', 'a[data-pay-application-licence-fee]', function(e) {
                e.preventDefault();
                const activity_id = $(this).attr('pay-licence-fee-for');
                const application_id = $(this).attr('data-pay-application-licence-fee');
                vm.payLicenceFee(application_id, activity_id);
            });                       
            // Child row listener
            vm.visibleDatatable.vmDataTable.on('click', 'tr.appRecordRow', async function(e) {
                // If a link is clicked, ignore
                if($(e.target).is('a')){
                    return;
                }
                // Generate child row for application
                var tr = $(this);
                var row = vm.visibleDatatable.vmDataTable.row(tr);

                await vm.getActivities(row.data()['id'])
                if (row.child.isShown()) {
                    // This row is already open - close it
                    row.child.hide();
                    tr.removeClass('shown');
                }
                else {
                    // Open this row (the format() function would return the data to be shown)
                    var child_row = ''
                    // Generate rows for each activity if internal
                    var activity_rows = ''
                    var activity_invoice_url = ''
                    vm.activities.forEach(function(activity) {
                        activity_rows += `
                            <tr>
                                <td>${activity['activity_name_str']}</td>
                                
                                <td>${activity['activity_purpose_names_status']['name_string'].
                                    replace(/(?:\r\n|\r|\n|,)/g, '<br>')}</td>
                                ${vm.is_external ? '' : activity['officer_name'] == null ?  `<td>&nbsp;</td>`: `<td>${activity['officer_name']}</td>`}    
    
                                ${vm.is_external ? '' : `<td>${activity['activity_purpose_names_status']['status_string'].
                                    replace(/(?:\r\n|\r|\n|,)/g, '<br>')}</td>`}

                                ${vm.is_external ? '' : `<td>${activity['can_pay_licence_fee'] ?
                                    `<a pay-licence-fee-for='${activity['id']}' application-id='${row.data()['id']}'>Pay licence fee</a>` : ''}
                                </td>`}
                            </tr>`;
                        activity_invoice_url = activity['invoice_url']
                    });
                    // Generate html for child row
                    child_row += `
                        <table class="table table-striped table-bordered child-row-table">
                            <tr>
                                <td class="width_20pc"><strong>Submitter:&nbsp;</strong></td>
                                <td>&nbsp;&nbsp;${row.data()['submitter']['first_name']}
                                    ${row.data()['submitter']['last_name']}</td>
                            </tr>`;

                    child_row += `
                            <tr>
                                <td><strong>Payment Status:&nbsp;</strong></td>
                                <td>&nbsp;&nbsp;${row.data()['payment_status']}</td>
                            </tr>
                            ${activity_invoice_url ?
                            `<tr>
                                <td><strong>Invoice:&nbsp;</strong></td>
                                <td><a href="${activity_invoice_url}'" target="_blank"><i style="color:red" class="fa fa-file-pdf-o"></i></a></td>
                            </tr>` : ' ' } `;

                    child_row += `</table>`
                    child_row += `
                        <table class="table table-striped table-bordered child-row-table">
                            <tr>
                                <th>Activity</th>
                                <th class="width_55pc">Purposes</th>
                                ${vm.is_external ? '' : '<th class="width_20pc">Assigned Officer</th>'}                            
                                ${vm.is_external ? '' : '<th class="width_10pc">Status</th>'}
                                ${vm.is_external ? '' : '<th class="width_10pc">Action</th>'}
                            </tr>
                            ${activity_rows}
                        </table>`;
                    // Show child row, dark-row className CSS applied from application.scss
                    row.child(
                        child_row
                        , 'dark-row').show();
                    tr.addClass('shown');
                }

                // Add listener for "Pay Licence Fee"
                row.on('click', 'a[pay-licence-fee-for]', function(e) {
                    e.preventDefault();
                    const activity_id = $(this).attr('pay-licence-fee-for');
                    const application_id = $(this).attr('application-id');
                    vm.payLicenceFee(application_id, activity_id);
                });
            });
        },
        initialiseSearch:function(){
            this.submitterSearch();
            this.dateSearch();
        },
        submitterSearch:function(){
            let vm = this;
            vm.visibleDatatable.table.dataTableExt.afnFiltering.push(
                function(settings,data,dataIndex,original){
                    let filtered_submitter = vm.filterApplicationSubmitter;
                    if (filtered_submitter == 'All'){ return true; }
                    return filtered_submitter == original.submitter.email;
                }
            );
        },
        dateSearch:function(){
            let vm = this;
            vm.visibleDatatable.table.dataTableExt.afnFiltering.push(
                function(settings,data,dataIndex,original){
                    let from = vm.filterApplicationLodgedFrom;
                    let to = vm.filterApplicationLodgedTo;
                    let val = original.lodgement_date;

                    if ( from == '' && to == ''){
                        return true;
                    }
                    else if (from != '' && to != ''){
                        return val != null && val != '' ? moment().range(moment(from,vm.dateFormat),moment(to,vm.dateFormat)).contains(moment(val)) :false;
                    }
                    else if(from == '' && to != ''){
                        if (val != null && val != ''){
                            return moment(to,vm.dateFormat).diff(moment(val)) >= 0 ? true : false;
                        }
                        else{
                            return false;
                        }
                    }
                    else if (to == '' && from != ''){
                        if (val != null && val != ''){
                            return moment(val).diff(moment(from,vm.dateFormat)) >= 0 ? true : false;
                        }
                        else{
                            return false;
                        }
                    }
                    else{
                        return false;
                    }
                }
            );
        },
        getColumnIndex: function(column_name) {
            return this.visibleHeaders.map(header => header.toLowerCase()).indexOf(column_name.toLowerCase());
        },
        initialiseSelects: async function() {

            await this.$http.get(helpers.add_endpoint_join(api_endpoints.applications,'1/get_application_selects')).then(res=>{

                    this.application_status = res.body.all_status
                    this.application_licence_types = res.body.all_category
                    this.application_activities = res.body.all_activity
                },err=>{

                    swal(
                        'Get Application Selects Error',
                        helpers.apiVueResourceError(err),
                        'error'
                    )
                });
        },
    },
    mounted: function(){
        let vm = this;
        vm.loadCurrentUser({ url: `/api/my_user_details` });     
        $( 'a[data-toggle="collapse"]' ).on( 'click', function () {
            var chev = $( this ).children()[ 0 ];
            window.setTimeout( function () {
                $( chev ).toggleClass( "glyphicon-chevron-down glyphicon-chevron-up" );
            }, 100 );
        });
        this.$nextTick(() => {
            vm.initialiseSearch();
            vm.addEventListeners();
            vm.initialiseSelects();
        });
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// applications_dashboard.vue?01d2a7bb